<template>
  <CreateOrUpdateConfigurationModal />
  <div class="card mb-25 border-0 radius-7 bg-white students-progress-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between"
      >
        <h5 class="card-title fw-bold mb-0">Configurações de upload via SFTP</h5>
      </div>

          <div v-for="(value, key) in getConfigurationSftp" :key="key" class="accordion pt-20" id="faqAccordion">
            <div class="accordion-item rounded-0 border-0">
              <button
                class="accordion-button shadow-none border-0 rounded-0 fs-14 fs-md-15 fs-lg-16 text-black fw-medium d-block w-100 text-start radius-7"
                type="button"
                aria-expanded="true"
                aria-controls="faqCollapseOne"
                data-bs-toggle="modal" 
                data-bs-target="#CreateOrUpdateConfigurationModal"
                @click="this.setCurrentConfigurationSftp(value)"
              >
              {{ key + 1 }} - {{ value.name }}
              </button>
            </div>
          </div>

          <div class="col-12">
            <button data-bs-toggle="modal" data-bs-target="#CreateOrUpdateConfigurationModal" @click="this.setCurrentConfigurationSftp(null)" class="btn btn-success mt-20 d-flex align-items-center"><i class="flaticon flaticon-plus d-flex me-10"></i> Criar nova configuração SFTP</button>
          </div>

    </div>
  </div>
</template>

<script>
import "vue3-circle-progress/dist/circle-progress.css";
import { mapGetters, mapActions } from 'vuex';
import CreateOrUpdateConfigurationModal from './CreateOrUpdateConfigurationModal.vue';

export default {
  name: "UpdateConfigurationsSftp",
  data() {
    return {};
  },
  components: {
    CreateOrUpdateConfigurationModal
  },
  computed: {
    ...mapGetters([
      'getConfigurationSftp'
    ])
  },
  mounted(){
    this.setConfigurationSftp();
  },
  methods: {
    ...mapActions([
      "setConfigurationSftp",
      "setCurrentConfigurationSftp"
    ])
  }
};
</script>